/*
* Configuration for Customer
*/
export default function () {
  return {
    projects: {
      defaultProjectCards: false,
      advancedContactSalesRep: false,
      globalContactSalesRepButton: true,
      showProjectCardCustomization: true
    },
    introProjectsOverlay: {
      enable: false
    },
    shortRegistrationInModal: true,
    onlyCorporateEmailOnRegistration: false
  }
}
